import React, { useContext, useMemo } from 'react';
import styles from './RecordCompareMaster.module.scss';
import MasterColumn from './RecordCompareMasterColumn';
import { Column, Row } from '../Layout/RecordCompareLayout';
import I18n from '../../../I18n/I18n/I18n';
import HelpIndicator from '../../../HelpIndicator/HelpIndicator';
import { getRowId } from '../../util/recordCompareAria';
import RecordCompareStateContext from '../../RecordCompareStateContext';
export default function MasterRow(_ref) {
  var records = _ref.records;
  var _useContext = useContext(RecordCompareStateContext),
    cardView = _useContext.cardView;
  var labelI18n = useMemo(function () {
    return {
      id: '@dm/components.record-compare.labels.master-help-label'
    };
  }, []);
  var helpI18n = useMemo(function () {
    return {
      id: '@dm/components.record-compare.labels.master-help'
    };
  }, []);
  return /*#__PURE__*/React.createElement(Row, null, !cardView ? /*#__PURE__*/React.createElement(Column, {
    id: getRowId('_master')
  }, /*#__PURE__*/React.createElement(I18n, {
    i18n: "@dm/components.record-compare.labels.master"
  }), /*#__PURE__*/React.createElement("span", {
    className: styles.help
  }, /*#__PURE__*/React.createElement(HelpIndicator, {
    label: labelI18n,
    i18n: helpI18n
  }))) : null, records.map(function (record, index) {
    return /*#__PURE__*/React.createElement(MasterColumn, {
      key: record.id,
      index: index,
      recordId: record.id
    });
  }));
}